export default function () {
    return [
        'প্রচুর পানি খাবেন',
        'পরিমান মত পানি খাবেন',
        'গরম পানি খাবেন',
        'চিনি কম খাবেন',
        'সাক-সবজি বেশি খাবেন',
        'মিষ্টি জাতীয় খাবার কম খাবেন'
    ];
}
